import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import LayoutMain_Kratos from "../LayoutMain_Kratos/LayoutMain_Kratos";
import { decodeToken } from "react-jwt";
import WaterMark from "../../Dashboard/DashboardMain/WaterMark";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";
import "./VehicleInsightKratos.css";

export default function VehicleInsights_Kratos() {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const [isDriveKratosEnable, setIsDriveKratosEnable] = useState(false);
  const [isChargingEnable, setIsChargingEnable] = useState(false);
  const [usernameTempHideShow, setUsernameTempHideShow] = useState(false);
  const [isCriticalVehicles, setCriticalVehicles] = useState(false);
  const [isCriticalVehiclesFleet, setCriticalVehiclesFleet] = useState(false);
  const [isTrendEnable, setIsTrendEnable] = useState(false);
  const [isEnergyAnalysis, setIsEnergyAnalysis] = useState(false);
  const [isEnergyBillReconcilliationFleet, setIsEnergyBillReconcilliationFleet] = useState(false);
  const [isFaultKratosEnable, setIsFaultKratosEnable] = useState(false);

  const loggedInUser = useSelector(selectLoggedInUser);

  const log_data = (data) => {

  };
  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "auth/logging",
        body: {
          page_name: "vehicleinsights_kratos",
        },
      },
      log_data
    );
  }, []);

  useEffect(() => {
    const tokenNew = JSON.parse(sessionStorage.user);
    let decodedToken = decodeToken(tokenNew.token);
    const usernameNew = decodedToken.access_type;
    var split_str = usernameNew.split(",");

    if (split_str.indexOf("1") !== -1) {
      setIsDriveKratosEnable(true);
    }
    if (split_str.indexOf("2") !== -1) {
      setIsChargingEnable(true);
    }
    if (split_str.indexOf("3") !== -1) {
      setCriticalVehicles(true);
    }
    if (split_str.indexOf("4") !== -1) {
      setIsEnergyAnalysis(true);
    }
    if (split_str.indexOf("5") !== -1) {
      setCriticalVehiclesFleet(true);
    }
    if (split_str.indexOf("6") !== -1) {
      setIsFaultKratosEnable(true);
    }
  }, [
    isDriveKratosEnable,
    isChargingEnable,
    isCriticalVehicles,
    isEnergyAnalysis,
    isCriticalVehiclesFleet,
    isFaultKratosEnable
  ]);

  const formatApiResponse = (data) => {
    if (typeof data !== "string") {
      data = String(data); // Convert non-string data to a string
    }

    let lines = data.split("\n");

    lines = lines.map((line) => {
      if (typeof line === "string") {
        return line.replace(/^\d+\s+/, "");
      }
      return line;
    });
    return lines.join("\n");
  };

  return (
    <LayoutMain_Kratos>
      <div className="row kratos_bg_c">
        <WaterMark />
        {loggedInUser.flagForHideShow === "ERC" && isCriticalVehicles && (
          <div className="col-md-3">
            <Link to="/dashboard_kratos/criticalvehicles_kratos">
              <div className="dashboard_card">
                <img
                  src="../../../assets/img_Bus/Critical_Vehicles.png"
                  alt=""
                />
                <span>Critical Vehicles</span>
              </div>
            </Link>
          </div>
        )
        }
        {loggedInUser.flagForHideShow === "FLEETEV" && isCriticalVehicles && (
            <div className="col-md-3">
              <Link to="/dashboard_kratos/criticalvehicles_kratos_ascent">
                <div className="dashboard_card">
                  <img
                    src="../../../assets/img_Bus/Critical_Vehicles.png"
                    alt=""
                  />
                  <span>Critical Vehicles Fleet</span>
                </div>
              </Link>
            </div>
          )
        }
        {isDriveKratosEnable && (
          <div className="col-md-3">
            <Link to="/dashboard_kratos/driveanalysis_kratos">
              <div className="dashboard_card">
                <img
                  src="../../../assets/img_Bus/drive_analysis_bus.png"
                  alt=""
                />
                <span>Drive Analysis</span>
              </div>
            </Link>
          </div>
        )}
        {isChargingEnable && (
          <div className="col-md-3">
            <Link to="/dashboard_kratos/charginganalysis_kratos">
              <div className="dashboard_card">
                <img
                  src="../../../assets/img_Bus/CESL_Charging/charging_bus_main_card.png"
                  alt=""
                />
                <span>Charging Analysis</span>
              </div>
            </Link>
          </div>
        )}
        {
          // (loggedInUser.flagForHideShow === "ERC" && isEnergyAnalysis) && (
          isEnergyAnalysis && (
            <div className="col-md-3">
              <Link to="/dashboard_kratos/energyanalysis_kratos">
                <div className="dashboard_card">
                  <img
                    src="../../../assets/img_Bus/Energy_Analytics.png"
                    alt=""
                  />
                  <span>Energy Analytics</span>
                </div>
              </Link>
            </div>
          )
        }
        {isFaultKratosEnable && (
            <div className="col-md-3">
              <Link to="/dashboard_kratos/faultanalysis_kratos">
                <div className="dashboard_card">
                  <img
                    src="../../../assets/img_Bus/fault_analysis_bus.png"
                    alt=""
                  />
                  <span>Fault Analysis</span>
                </div>
              </Link>
            </div>
          )
        }
      </div>
    </LayoutMain_Kratos>
  );
}
